import { forwardRef } from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

type InternalProps = {
	onChange: (event: { target: { value: string } }) => void;
};

export const AccountInput = forwardRef<NumericFormatProps, InternalProps>((props, ref) => {
	const { onChange, ...rest } = props;

	return (
		<NumericFormat
			{...rest}
			allowLeadingZeros={false}
			allowNegative={false}
			decimalScale={0}
			getInputRef={ref}
			onValueChange={(values) =>
				onChange({
					target: {
						value: values.value,
					},
				})
			}
		/>
	);
});
